export default __webpack_public_path__ + "static/media/falcon_mandala_black_and_red.789d6ae9.jpg";